import lib from "./lib/lib.js";

export const sliderLightbox = {
  init: () => {
    // Initialise the lightbox

    // Slider Lightbox Container
    lib.qsa(".slider-lightbox-container").forEach((elem) => {
      let btn = elem.querySelector(".slider-lightbox-btn");
      let overlay = elem.querySelector(".slider-lightbox-overlay");
      let lightbox = elem.querySelector(".slider-lightbox");
      let close = elem.querySelector(".slider-lightbox-close");

      const refreshItem = () => {
        window.app.splide.forEach((item) => {
          item.refresh();
        });
      };

      // Button add lightbox
      btn.addEventListener("click", () => {
        elem.classList.add("active");
        refreshItem();
      });

      // Lightbox remove overlay
      overlay.addEventListener("click", () => {
        elem.classList.remove("active");
        refreshItem();
      });

      // Close Button - Remove overlay
      close.addEventListener("click", () => {
        elem.classList.remove("active");
        refreshItem();
      });
    });
  },
};
